import { render, staticRenderFns } from "./dxDataGridWrapper.vue?vue&type=template&id=35d6c4f4"
import script from "./dxDataGridWrapper.vue?vue&type=script&lang=js"
export * from "./dxDataGridWrapper.vue?vue&type=script&lang=js"
import style0 from "./dxDataGridWrapper.vue?vue&type=style&index=0&id=35d6c4f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports